import ExportBase from "../exportbase";


import LabelDialog from "../../../../../dialogs/labeldialog";
import DialogInputBox from "../../../../../dialogs/inputbox";


import React from "react";

class ExportSTJson extends ExportBase 
{


constructor(props)
{
    super(props);

    this.state.formulaire =
    {

        cp:false,
        stats: false,
        configuration: false,
    }
        
    
    this.cpRef = React.createRef();
    this.statsRef = React.createRef();
    this.configurationRef = React.createRef();


    this.onAssetDownloaded = this.onAssetDownloaded.bind(this)
    this.handleOnChange = this.handleOnChange.bind(this)


    this.ready = false;
    this.lastFormulaireSend = "";

}

componentDidMount()
{
    super.componentDidMount();
    
    
}

componentDidUpdate()
{
    super.componentDidUpdate()
    
}

createWorker()
{
    
    return new Worker(new URL('./jsonstworker.js', import.meta.url));
}

sendFormulaire()
{
    
    var datas = {};
    datas = {
        cp: this.cpRef.current.getValue(),
        configuration: this.configurationRef.current.getValue(),
        stats: this.statsRef.current.getValue(),
    }
    if (this.lastFormulaireSend !== JSON.stringify(datas))
    {
               this.lastFormulaireSend = JSON.stringify(datas);
            this.startComputeFile(datas)
    }

    
    
}


handleOnChange()
{
    if (this.ready) this.sendFormulaire();
};

onAssetDownloaded(asset)
{
   
    this.ready = true;

}

render()

{
    // <>{this.props.format}<br/>{this.props.type}<br/>{this.props.title}<br/>{this.props.asid}</>

    return super.render(

    <>
        <LabelDialog
        width = "96%"
        title = {this.context.language=="fr"?"Type de fichier":"File type"}
        />

        <DialogInputBox
        value = {this.state.formulaire.configuration}
        disabled={false}
        autoFocus = {false}
        ref = {this.configurationRef}
        onChange =  {this.handleOnChange}
        title = {this.context.language=="fr"?" Avec configuration":" With configuration"}
        />
        <br/>
        <DialogInputBox
        value = {this.state.formulaire.stats}
        disabled={false}
        autoFocus = {false}
        ref = {this.statsRef}
        onChange =  {this.handleOnChange}
        title = {this.context.language=="fr"?" Avec statistiques":" With statistiques"}
        />
        <br/>
        <DialogInputBox
        value = {this.state.formulaire.cp}
        disabled={false}
        autoFocus = {false}
        ref = {this.cpRef}
        onChange =  {this.handleOnChange}
        title = {this.context.language=="fr"?" Avec changements de plan":" With shots"}
        />

        <br/>

        <br/>
        
    </>
        
    )
}
}

export default ExportSTJson;